export const FILTERS_QUERY_PARAM = "filters_param";
export const SORTBY_QUERY_PARAM = "sortby";
export const SEARCH_QUERY_PARAM = "s";
